import { t } from 'i18next'
import { useEffect, useMemo } from 'react'
import { FaCaretDown } from 'react-icons/fa'

const SelectColumnFilterPaginated = ({
  column,
  handleFilterChange,
  providedOptions = [],
  advancedOptions = false,
  searchParams = '',
}) => {
  const { filterValue, setFilter, preFilteredRows, id } = column

  const options = useMemo(() => {
    const options = new Set()
    preFilteredRows?.forEach((row) => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  //if it is using qery params
  const queryParams = searchParams ? new URLSearchParams(decodeURIComponent(searchParams.toString())) : ''
  const columnId = id // accessor name from column definition
  const columnValue = queryParams ? queryParams.get(columnId) : ''

  useEffect(() => {
    if (columnValue) {
      setFilter(columnValue)
    }
  }, [columnValue])

  return (
    <>
      <select
        className="bg-white border-neutral text-secondary rounded-lg p-2 w-24"
        value={filterValue}
        onChange={(e) => {
          if (columnValue) {
            setFilter(columnValue) // Set undefined to remove the filter entirely
          }
          setFilter(e.target.value || undefined)
          handleFilterChange(e.target.value, column.id)
        }}
      >
        <option className="w-full px-10" value="">
          {t('all')}
        </option>
        {
          !advancedOptions
            ? providedOptions && providedOptions.length > 0
              ? providedOptions.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))
              : options.map((option, i) => (
                  <option key={i} value={option}>
                    {option}
                  </option>
                ))
            : providedOptions && providedOptions.length > 0
              ? providedOptions.map((option, i) => (
                  <option key={i} value={option.value}>
                    {option.label}
                  </option>
                ))
              : null // You can render an empty list if advancedOptions is false
        }
      </select>
    </>
  )
}

export default SelectColumnFilterPaginated
